import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { toggleMenuAction } from "../../Store/Actions/AuthActions";

const getInitials = (name) => {
  if (!name || typeof name !== "string") return "";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const TopHeader = ({ title }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const menuOpen = useSelector((state) => state.auth.isMenuOpen);
  const [imageFailed, setImageFailed] = useState(false);

  // Reset failure flag when the image source changes.
  useEffect(() => {
    setImageFailed(false);
  }, [user && user.image]);

  const initials = getInitials(user && user.name);
  const showImage = user && user.image && !imageFailed;
  // Admins land on the admin area; everyone else opens the user profile page.
  const isAdmin = user && user.type === "admin";

  const avatar = showImage ? (
    <img
      src={user.image}
      alt={user.name}
      onError={() => setImageFailed(true)}
    />
  ) : (
    initials
  );

  return (
    <div class="header-top-menu">
      <div class="row">
        <div class="col">
          <div className="pageHeading d-flex">
            <button
              type="button"
              className="mobile-menu-toggle"
              aria-label="Toggle menu"
              onClick={() => toggleMenuAction(!menuOpen, dispatch)}
            >
              <i className="fas fa-bars" />
            </button>
            <h2>{title}</h2>
          </div>
        </div>
        <div class="col">
          <div class="user-info">
            {isAdmin ? (
              <div class="user-img">{avatar}</div>
            ) : (
              <div
                className="user-img user-img-link"
                role="button"
                tabIndex={0}
                title="Profile"
                onClick={() => navigate("/user/profile")}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    navigate("/user/profile");
                  }
                }}
              >
                {avatar}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopHeader;
